import React from 'react'
import { Alert, Button, Row } from 'reactstrap'
import AutoTable from 'components/AutoTable'
import { NetSuiteAsset } from 'types'

interface UnassignedLicensesGridProps {
  assets: NetSuiteAsset[]
  onSetupLicense?: (asset: NetSuiteAsset) => void
  isExpired?: boolean
}

const UnassignedLicenseGrid: React.FC<UnassignedLicensesGridProps> = ({
  assets,
  onSetupLicense,
  isExpired = false,
}) => {
  const columns = [
    {
      title: 'License ID',
      fieldValue: 'nsName',
    },
    ...(onSetupLicense
      ? [
          {
            title: '',
            fieldValue: (asset: NetSuiteAsset) => {
              return (
                !isExpired && (
                  <Button
                    data-testid="SETUP-DATA-TEST-ID"
                    color="light"
                    onClick={() => onSetupLicense(asset)}
                    size="sm"
                    style={{ float: 'right' }}
                  >
                    <i className="fas fa-cogs text-primary" />
                    &nbsp;Setup
                  </Button>
                )
              )
            },
            sort: false,
            filter: false,
          },
        ]
      : []),
  ]

  return assets.length ? (
    <Row>
      <AutoTable
        borderless
        columns={columns}
        filter
        headThemeLight
        rows={assets}
        sort
      />
    </Row>
  ) : (
    <Alert color="success" style={{ width: '100%' }}>
      No unassigned assets found
    </Alert>
  )
}

export default UnassignedLicenseGrid
